var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-outfit-semi-bold"},[_c('img',{attrs:{"src":require("@/assets/img/onboarding/onboarding-user-details-illustration.svg"),"alt":"onboarding user details illustration image"}})])
}]

export { render, staticRenderFns }